import DigitalDeliveryOnlyAddress from 'components/checkout/caap/addressformats/DigitalDeliveryOnlyAddress';
import HighlightedAddress from 'components/checkout/caap/addressformats/HighlightedAddress';
import SingeLineAddress from 'components/checkout/caap/addressformats/SingleLineAddress';
import SingeLineSimpleAddress from 'components/checkout/caap/addressformats/SingeLineSimpleAddress';
import MultiLineAddress from 'components/checkout/caap/addressformats/MultiLineAddress';

const Address = params => {
  const {
    address = {},
    baseAddress = {},
    children,
    isBaseForHighlight = false,
    isDigitalDeliveryOnly,
    isSingleLineSimple,
    multiLineDisplay,
    nameOnAddressLine,
    onChangeAddressClick,
    isSelected
  } = params;

  if (!address || !Object.keys(address).length) {
    return null;
  }

  if (isSingleLineSimple) {
    return <SingeLineSimpleAddress address={address} />;
  }

  if (isDigitalDeliveryOnly) {
    return <DigitalDeliveryOnlyAddress />;
  }

  if (Object.keys(baseAddress).length) {
    return <HighlightedAddress address={address} baseAddress={baseAddress} />;
  }

  if (multiLineDisplay) {
    return <MultiLineAddress
      address={address}
      editLink={children}
      isBaseForHighlight={isBaseForHighlight}
      onChangeAddressClick={onChangeAddressClick}
      isSelected={isSelected} />;
  }

  return <SingeLineAddress address={address} nameOnAddressLine={nameOnAddressLine} />;
};

export default Address;
